import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { launchPhoneBurner } from '../../../common/utils';

import '../modals.css';

const LaunchPhoneBurner = ( { close, viewing, uid, stack, opps, loans, contacts, type, data } ) => {
    const [ selectedItems, setSelectedItems ] = useState( [] );
    const [ processing, setProcessing ] = useState( false );
    
    const launch = async () => {
        setProcessing( true );
        
        const cids = [];
        const list = [];

        if ( type === 'leads' ) {
            for ( const loid of data ) {
                const opp = opps[loid];
                if ( opp?.relationships?.length ) {
                    for ( let i = 0; i < opp.relationships.length; i++ ) {
                        const c = contacts[opp.relationships[i].cid];
                        if ( !c ) {
                            continue;
                        }

                        if ( i === 0 && selectedItems.includes( 'Primary Borrower' ) ) {
                            cids.push( c.cid );
                            list.push( c );
                        } else if ( i === 1 && selectedItems.includes( 'Co-Borrower' ) ) {
                            cids.push( c.cid );
                            list.push( c );
                        }
                        if ( selectedItems.includes( 'Referral Partner' ) && c.referredById ) {
                            const r = contacts[c.referredById];
                            if ( r ) {
                                cids.push( r.cid );
                                list.push( r );
                            }
                        }
                    }
                }
            }
        } else if ( type === 'loans' ) {
            for ( const lid of data ) {
                const l = loans[lid];
                if ( !l ) {
                    continue;
                }

                if ( l.borrowers?.length ) {
                    for ( const b of l.borrowers ) {
                        const c = contacts[b.cid];
                        if ( !c ) {
                            continue;
                        }

                        if ( b.label === 'Primary' && selectedItems.includes( 'Primary Borrower' ) ) {
                            cids.push( c.cid );
                            list.push( c );
                        } else if ( b.label === 'Co-Borrower' && selectedItems.includes( 'Co-Borrower' ) ) {
                            cids.push( c.cid );
                            list.push( c );
                        }
                        if ( c.referredById && selectedItems.includes( 'Referral Partner' ) ) {
                            const r = contacts[c.referredById];
                            if ( r ) {
                                cids.push( r.cid );
                                list.push( r );
                            }
                        }
                    }
                }

                if ( l.baId && selectedItems.includes( 'Buyer\'s Agent' ) ) {
                    const c = contacts[l.baId];
                    if ( c ) {
                        cids.push( c.cid );
                        list.push( c );
                    }
                }

                if ( l.laId && selectedItems.includes( 'Listing Agent' ) ) {
                    const c = contacts[l.laId];
                    if ( c ) {
                        cids.push( c.cid );
                        list.push( c );
                    }
                }
            }
        }

        await launchPhoneBurner( viewing[0], uid, cids, list, stack.dialer );
        close();
    }

    const handleChange = ( event ) => {
        const { value, checked } = event.target;
        setSelectedItems( ( prev ) =>
            checked ? [ ...prev, value ] : prev.filter( ( item ) => item !== value )
        );
    };

    const getOptionList = () => {
        if ( type === 'leads' ) {
            return [
                'Primary Borrower',
                'Co-Borrower',
                'Referral Partner',
            ];
        } else if ( type === 'loans' ) {
            return [
                'Primary Borrower',
                'Co-Borrower',
                'Buyer\'s Agent',
                'Listing Agent',
                'Referral Partner',
            ];
        }
        return [];
    };
    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    const optionList = getOptionList();

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Who You Gonna Call?</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <Row className='py-3'>
                                <Col>
                                {
                                    optionList.map( ( option ) => (
                                        <Form.Group key={option} as={Row} className='py-2 fs-6'>
                                            <Col>
                                                <Form.Check
                                                    type="checkbox"
                                                    label={option}
                                                    value={option}
                                                    checked={ selectedItems.includes( option ) }
                                                    onChange={ handleChange }
                                                />
                                            </Col>
                                        </Form.Group>
                                    ) )
                                }
                                </Col>
                            </Row>
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => launch() } disabled={ selectedItems.length === 0 }>Launch</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    viewing: state.user.viewing,
    uid: state.user.email,
    stack: state.user.stack,
    contacts: state.contacts.byId,
    opps: state.leadopps.byId,
    loans: state.loans.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( LaunchPhoneBurner );